const COUNTRY_CALLING_CODES = [
  '+62',
  '+1',
  '+1-242',
  '+1-264',
  '+1-268',
  '+1-340',
  '+1-345',
  '+1-441',
  '+1-473',
  '+1-671',
  '+1-758',
  '+1-767',
  '+1-784',
  '+1-809',
  '+1-829',
  '+1-868',
  '+1-876',
  '+1-939',
  '+20',
  '+212',
  '+213',
  '+218',
  '+220',
  '+221',
  '+222',
  '+223',
  '+224',
  '+225',
  '+226',
  '+227',
  '+229',
  '+230',
  '+231',
  '+232',
  '+233',
  '+234',
  '+235',
  '+236',
  '+237',
  '+238',
  '+239',
  '+240',
  '+241',
  '+242',
  '+243',
  '+244',
  '+245',
  '+248',
  '+249',
  '+250',
  '+251',
  '+252',
  '+253',
  '+255',
  '+256',
  '+257',
  '+258',
  '+260',
  '+261',
  '+262',
  '+263',
  '+265',
  '+266',
  '+267',
  '+268',
  '+269',
  '+27',
  '+290',
  '+291',
  '+297',
  '+298',
  '+30',
  '+31',
  '+32',
  '+33',
  '+34',
  '+350',
  '+351',
  '+352',
  '+353',
  '+354',
  '+355',
  '+356',
  '+357',
  '+358',
  '+36',
  '+370',
  '+371',
  '+372',
  '+373',
  '+375',
  '+376',
  '+377',
  '+378',
  '+380',
  '+381',
  '+385',
  '+386',
  '+387',
  '+389',
  '+39',
  '+40',
  '+41',
  '+418',
  '+420',
  '+421',
  '+423',
  '+43',
  '+44',
  '+45',
  '+46',
  '+47',
  '+48',
  '+49',
  '+5',
  '+50',
  '+500',
  '+501',
  '+502',
  '+503',
  '+504',
  '+505',
  '+506',
  '+507',
  '+508',
  '+509',
  '+51',
  '+52',
  '+53',
  '+53',
  '+54',
  '+55',
  '+56',
  '+57',
  '+58',
  '+590',
  '+591',
  '+592',
  '+593',
  '+594',
  '+595',
  '+596',
  '+597',
  '+598',
  '+599',
  '+60',
  '+61',
  '+61',
  '+63',
  '+64',
  '+65',
  '+66',
  '+670',
  '+672',
  '+672',
  '+673',
  '+674',
  '+675',
  '+676',
  '+677',
  '+678',
  '+679',
  '+680',
  '+681',
  '+682',
  '+683',
  '+686',
  '+687',
  '+689',
  '+690',
  '+691',
  '+692',
  '+7',
  '+7',
  '+70',
  '+71',
  '+72',
  '+73',
  '+74',
  '+75',
  '+76',
  '+77',
  '+78',
  '+79',
  '+80',
  '+81',
  '+82',
  '+84',
  '+85',
  '+86',
  '+87',
  '+88',
  '+89',
  '+90',
  '+91',
  '+92',
  '+93',
  '+94',
  '+95',
  '+96',
  '+962',
  '+965',
  '+966',
  '+967',
  '+968',
  '+969',
  '+970',
  '+971',
  '+972',
  '+973',
  '+974',
  '+975',
  '+976',
  '+977',
  '+98',
  '+992',
  '+994',
  '+995',
  '+996',
  '+998',
  '+999',
]

export { COUNTRY_CALLING_CODES }
